import { getCountries } from "../../../api/countries";
import { languageTempletsOptions } from "../../../utils/langTemplets";

export const REQUIRED_FIELDS = [
  { key: "name", label: "Name" },
  { key: "email", label: "email", type: "email" },
  {
    key: "gender",
    label: "Gender",
    type: "fixed-select",
    options: [
      { label: "Male", value: "male" },
      { label: "Female", value: "female" },
    ],
  },
  { key: "iban", label: "IBAN" },
  { key: "bic", label: "BIC" },
  { key: "bank_country", label: "Bank Country" },
];

export const MEDIA_FIELDS = [
  ...REQUIRED_FIELDS,
  { key: "call_name", label: "Call Name" },
  { key: "first_name", label: "first_name" },
  { key: "last_name", label: "last_name" },
  { key: "birth_date", label: "birth_date", type: "date" },

  {
    key: "nationality",
    label: "nationality",
    type: "select",
    apiResKey: "countries",
    api: getCountries,
  },
  { key: "city", label: "city" },
  { key: "home_address", label: "home_address" },
  { key: "residence_address", label: "residence_address" },
  { key: "zip_code", label: "zip_code" },
  { key: "house_number", label: "house_number" },
  { key: "street", label: "street" },
  { key: "phone_number", label: "phone_number" },
  { key: "home_phone", label: "home_phone" },
  { key: "account_number", label: "account_number" },
  { key: "sofi_number", label: "sofi_number" },
  { key: "id_type", label: "id_type" },
  { key: "beneficiary", label: "beneficiary" },
  // { key: "id_number", label: "id_number" },
  // { key: "custom_id", label: "custom_id" },
  // { key: "id_name", label: "id_name" },
  {
    key: "preferredLanguage",
    label: "Prefered Language",
    type: "fixed-select",
    options: [...languageTempletsOptions],
  },
  { key: "id_front_side", label: "id_front_side", type: "file" },
  { key: "id_back_side", label: "id_back_side", type: "file" },
];

export const ADDITIONAL_FIELDS = [
  { key: "training", label: "training" },
  { key: "courses", label: "courses" },
  { key: "driving_license", label: "driving_license" },
  { key: "insurance_number", label: "insurance_number" },
  { key: "other_languages", label: "other_languages" },
  { key: "policy_number", label: "policy_number" },
  { key: "policy_cost", label: "policy_cost" },
  { key: "start_date", label: "start_date", type: "date" },
  { key: "end_date", label: "end_date", type: "date" },
  { key: "note", label: "note", type: "textarea" },
  {
    key: "blockPayments",
    label: "block_payments",
    type: "fixed-select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  { key: "insurance_type", label: "insurance_type" },
  {
    key: "insurance_active",
    label: "insurance_active",
    type: "fixed-select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  { key: "insurance_end_date", label: "insurance_end_date", type: "date" },
];

export const WORK_EXPERIENCE_REQUIRED_FIELDS = [
  { key: "jobTitle", label: "job Title" },
  { key: "company", label: "Company" },
  { key: "from", label: "From", type: "date" },
];
export const WORK_EXPERIENCE_FIELDS = [
  ...WORK_EXPERIENCE_REQUIRED_FIELDS,
  { key: "to", label: "To", type: "date" },
];

export const EDUCATION_FIELDS = [
  { key: "type", label: "Type" },
  { key: "period", label: "Period" },
  {
    key: "acceptable",
    label: "Acceptable",
    type: "fixed-select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
];

export const INFO_FIELDS = [
  { key: "name", label: "Name" },
  { key: "birth_date", label: "Date of bith", type: "date" },
  { key: "sofi_number", label: "Personal number (Sofi)" },
  { key: "gender", label: "Gender" },
  { key: "iban", label: "IBAN" },
  { key: "flex_assistant", label: "Flex Assistant" },
  { key: "pool_manager", label: "Pool Manager" },
  { key: "residence_address", label: "Residency" },
  { key: "company", label: "Current Company" },
  { key: "preferredLanguage", label: "Preferred Language", type: "lang" },
];

const FIELDS = [...MEDIA_FIELDS, ...ADDITIONAL_FIELDS];

export default FIELDS;
